import { useLazyQuery } from '@apollo/client';
import {
    SearchLocation,
    SearchLocationVariables
} from 'libs/graphql/query/interaction/__generated__/SearchLocation';
import { SEARCH_LOCATION_QUERY } from 'libs/graphql/query/interaction/interactionQuery';
import { useState } from 'react';
import { ICoordinates } from 'react-give-me-map';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
declare const google: any;

export const useSearchLocation = () => {
    const [items, setItems] = useState<ISearchPlace[]>([]);
    const [isLoadingItems, setIsLoadingItems] = useState(false);

    const [search] = useLazyQuery<SearchLocation, SearchLocationVariables>(SEARCH_LOCATION_QUERY, {
        onCompleted: (r) => {
            const arr: ISearchPlace[] = [];
            for (const search of r.searchLocation) {
                arr.push({
                    id: search.placeId,
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    text: (search as any)?.label
                });
            }
            setIsLoadingItems(false);
            setItems(arr);
        }
    });

    function findLocations(location: string) {
        setIsLoadingItems(true);
        search({
            variables: {
                query: location,
                limit: 5
            }
        });
    }

    function geolocate(
        placeId: string,
        placeText?: string
    ): Promise<{
        lat: number;
        lng: number;
        placeId: string;
        placeText?: string;
        bounds?: { leftTop: ICoordinates; rightBottom: ICoordinates };
    } | null> {
        const geocoder = new google.maps.Geocoder();
        return new Promise((resolve) => {
            geocoder.geocode({ placeId: placeId }).then(({ results }) => {
                if (results?.length > 0) {
                    const lat = results[0]?.geometry?.location?.lat();
                    const lng = results[0]?.geometry?.location?.lng();

                    const serverBounds =
                        results[0]?.geometry?.bounds ?? results[0]?.geometry?.viewport;
                    const northEast = serverBounds.getNorthEast();
                    const southWest = serverBounds.getSouthWest();

                    const bounds = serverBounds
                        ? {
                              leftTop: {
                                  lat: northEast.lat(),
                                  lng: northEast.lng()
                              },
                              rightBottom: {
                                  lat: southWest.lat(),
                                  lng: southWest.lng()
                              }
                          }
                        : null;
                    resolve({
                        lat,
                        lng,
                        placeId,
                        placeText,
                        bounds
                    });
                } else {
                    resolve(null);
                }
            });
        });
    }

    return {
        items,
        setItems,
        geolocate,
        findLocations,
        isLoadingItems
    };
};

interface ISearchPlace {
    id: string;
    text: string;
}
